/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TCianApiSiteV1FilterPikNewbuildingsRequest,
  TCianApiSiteV1FilterPikNewbuildingsModel,
  IMappers,
  TCianApiSiteV1FilterPikNewbuildingsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IFilterPikNewbuildingsResponseSchema82 } from '../../../../entities/schemas/FilterPikNewbuildingsResponseSchema82';
import type { IErrorResponseSchema83 } from '../../../../entities/schemas/ErrorResponseSchema83';

export function createCianApiSiteV1FilterPikNewbuildingsModel(
  parameters: TCianApiSiteV1FilterPikNewbuildingsRequest,
): TCianApiSiteV1FilterPikNewbuildingsModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'POST',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/filter-pik-newbuildings/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICianApiSiteV1FilterPikNewbuildingsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCianApiSiteV1FilterPikNewbuildingsRequest;
}

export async function fetchCianApiSiteV1FilterPikNewbuildings<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1FilterPikNewbuildingsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCianApiSiteV1FilterPikNewbuildingsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1FilterPikNewbuildingsModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1FilterPikNewbuildingsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IFilterPikNewbuildingsResponseSchema82, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema83, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1FilterPikNewbuildingsResponse>;
}
